import { CheckCircle, Clock, AlertTriangle, AlertCircle } from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

export const StatusBadge = ({ status }) => {
  const statusConfig = {
    active: { label: 'Activa', className: 'bg-emerald-100 text-emerald-700', icon: CheckCircle },
    pending: { label: 'Pendiente', className: 'bg-amber-100 text-amber-700', icon: Clock },
    consumed: { label: 'Consumida', className: 'bg-slate-200 text-slate-700', icon: AlertTriangle },
    expired: { label: 'Expirada', className: 'bg-red-100 text-red-700', icon: AlertCircle },
    cancelled: { label: 'Cancelada', className: 'bg-red-200 text-red-800', icon: AlertCircle }
  };
  const config = statusConfig[status] || statusConfig.pending;
  const Icon = config.icon;
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${config.className}`}>
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 }).format(amount);
};

export const channelNames = {
  'online': 'En línea', 'online_stripe': 'Stripe Online', 'admin': 'Administrador',
  'physical_card': 'Tarjeta Física', 'corporate': 'Corporativo', 'point_of_sale': 'Punto de Venta',
  'distributor': 'Distribuidor', 'presencial': 'Presencial', 'telefono': 'Teléfono'
};
